document.addEventListener('DOMContentLoaded', function () {
  var SUCCESS_VISIBLE_MS = 4200;
  var RESET_ANIMATION_MS = 500;
  var SESSION_EMAILS_KEY = 'arachne-footer-newsletter-emails';
  var PULSE_ANIMATION_NAME = 'footer-submitted-fade-pulse';

  function normalizeEmail(email) {
    return String(email || '').trim().toLowerCase();
  }

  function getSubmittedEmails() {
    try {
      var raw = window.sessionStorage.getItem(SESSION_EMAILS_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function hasSubmittedEmail(email) {
    return getSubmittedEmails().indexOf(normalizeEmail(email)) !== -1;
  }

  function rememberEmail(email) {
    var normalized = normalizeEmail(email);
    if (!normalized) return;

    var emails = getSubmittedEmails();
    if (emails.indexOf(normalized) !== -1) return;

    emails.push(normalized);

    try {
      window.sessionStorage.setItem(SESSION_EMAILS_KEY, JSON.stringify(emails));
    } catch (error) {
      // Ignore storage quota / private mode failures.
    }
  }

  document.querySelectorAll('.js-footer-newsletter').forEach(function (form) {
    var customInput = form.querySelector('.custom-input');
    var emailInput = form.querySelector('input[type="email"]');
    var submitButton = form.querySelector('.shop-brushes-button');
    var submittedBar = form.querySelector('.footer-newsletter-submitted');
    var resetTimer;
    var isBusy = false;
    var isResetting = false;

    if (!customInput || !emailInput || !submitButton || !submittedBar) return;

    form.setAttribute('novalidate', 'novalidate');
    submitButton.setAttribute('type', 'button');

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function validateEmail() {
      var emailValue = emailInput.value.trim();
      emailInput.value = emailValue;

      if (!emailValue) {
        emailInput.setCustomValidity('Please enter your email.');
        return false;
      }

      if (!isValidEmail(emailValue)) {
        emailInput.setCustomValidity('Please enter a valid email address.');
        return false;
      }

      if (hasSubmittedEmail(emailValue)) {
        emailInput.setCustomValidity('This email has already been submitted.');
        return false;
      }

      emailInput.setCustomValidity('');
      return true;
    }

    function showSubmittedState() {
      isResetting = false;
      customInput.classList.add('is-pulse-underlay');
      customInput.classList.add('is-submitted');
      emailInput.disabled = true;
      submitButton.disabled = true;
      submittedBar.disabled = false;
      submittedBar.setAttribute('aria-hidden', 'false');
    }

    function resetForm() {
      if (isResetting) return;

      isResetting = true;
      window.clearTimeout(resetTimer);
      customInput.classList.remove('is-submitted');
      customInput.classList.remove('is-pulse-underlay');
      submittedBar.setAttribute('aria-hidden', 'true');
      submittedBar.disabled = true;
      emailInput.value = '';

      window.setTimeout(function () {
        emailInput.disabled = false;
        submitButton.disabled = false;
        isBusy = false;
        isResetting = false;
      }, RESET_ANIMATION_MS);
    }

    function scheduleReset() {
      window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(resetForm, SUCCESS_VISIBLE_MS);
    }

    function submitToShopify(emailValue) {
      var params = new URLSearchParams();

      Array.from(form.elements).forEach(function (field) {
        if (!field.name || field.disabled) return;
        if (field.type === 'submit' || field.type === 'button') return;
        params.append(field.name, field.value);
      });

      params.set('contact[email]', emailValue);
      params.set('contact[tags]', 'newsletter');
      params.set('form_type', 'customer');

      var action = (form.getAttribute('action') || '/contact').split('#')[0];

      fetch(action, {
        method: 'POST',
        body: params.toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        redirect: 'manual',
      }).catch(function () {
        // Do not fall back to a native form submit.
      });
    }

    function handleUserSubmit(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      if (isBusy) return;

      if (!validateEmail()) {
        emailInput.reportValidity();
        return;
      }

      var emailValue = emailInput.value.trim();
      isBusy = true;
      rememberEmail(emailValue);
      submitToShopify(emailValue);
      showSubmittedState();
      scheduleReset();
    }

    emailInput.addEventListener('input', function () {
      emailInput.setCustomValidity('');
    });

    submittedBar.addEventListener('animationend', function (event) {
      if (event.animationName !== PULSE_ANIMATION_NAME) return;
      if (!customInput.classList.contains('is-submitted')) return;
      resetForm();
    });

    submitButton.addEventListener('click', handleUserSubmit);

    emailInput.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      handleUserSubmit(event);
    });

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    if (customInput.classList.contains('is-submitted')) {
      isBusy = true;
      customInput.classList.add('is-pulse-underlay');
      rememberEmail(emailInput.value);
      scheduleReset();
    }
  });
});
